import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { countries } from '@/lib/seo/countries'

export const Route = createFileRoute('/online-poker/countries/$country')({
  loader: ({ params }) => {
    const country = countries.find((c) => c.slug === params.country)
    if (!country) throw notFound()
    return country
  },
  component: () => <Outlet />,
})
